import { useSyncExternalStore } from 'react';

let ready = false;
const listeners = new Set<() => void>();

export const markAuthReady = () => {
  if (ready) return;
  ready = true;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useAuthReady = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => ready,
    () => false
  );
